import { getGroupTemplateId } from '../../helpers'
import { SingleUseLinkData } from './types'

export const getSingleUseLinkData = ({ isGroupType, linkName, bookingLink }: SingleUseLinkData) => {
  if (isGroupType) {
    return {
      groupTemplateId: getGroupTemplateId(bookingLink.link),
    }
  }
  return {
    assigneeName: linkName,
    templateId: bookingLink.templateId,
  }
}
